module.exports = {
  isFeatureEnabled: (feature, featureList) => {
    return featureList && featureList.includes(feature)
  },

  isAllRequiredFeaturesEnabled: (allRequiredFeatures, featureList) => {
    return featureList && allRequiredFeatures.reduce((all, requiredFeature) => all && featureList.includes(requiredFeature), true)
  },
}
